import { ref } from 'vue'

// Estado compartido entre todos los componentes que usen este composable
const syncingEscenarios = ref(false)
const syncEscenarioError = ref(null)
const syncEscenariosResult = ref(null)

export function useEscenariosSync() {
    /**
     * Dispara un re-sync de escenarios en el servidor envivo.
     * El servidor frontendhistorias actúa como proxy para no exponer credenciales al navegador.
     * Es fire-and-forget: no bloquea el flujo del llamador, los errores se loguean en consola.
     */
    async function syncEscenarios(serverName) {
        syncingEscenarios.value = true
        syncEscenarioError.value = null
        syncEscenariosResult.value = null

        try {
            const response = await fetch(`/api/${serverName}/escenarios/sync`, {
                method: 'POST',
                credentials: 'include',
            })

            const data = await response.json()

            if (!response.ok) {
                throw new Error(data.error || 'Error al sincronizar con envivo')
            }

            syncEscenariosResult.value = data
            console.log(`✅ Envivo sync: ${data.synced} escenarios sincronizados en el servidor ${serverName}`)
        } catch (err) {
            syncEscenarioError.value = err.message
            console.error('Error sincronizando escenarios con envivo:', err)
        } finally {
            syncingEscenarios.value = false
        }
    }

    return { syncingEscenarios, syncEscenarioError, syncEscenariosResult, syncEscenarios }
}